import * as Sentry from '@sentry/browser'
import _ from 'lodash'
import { Integrations } from '@sentry/tracing'

let CONFIGURATION = null

const initialize = configuration => {
  CONFIGURATION = configuration

  if ( !configuration?.SENTRY_DSN ) {
    console.warn( 'SENTRY_DSN is not configured. Sentry will not be initialized.' )
  }

  // Initialize Sentry
  if ( configuration?.SENTRY_DSN ) {

    // Defaults
    const options = {
      dsn: configuration.SENTRY_DSN,
      integrations: [ new Integrations.BrowserTracing() ],
      tracesSampleRate: 1.0,
    }

    // Additional configuration
    configuration.APPLICATION_ENVIRONMENT && _.set( options, 'environment', configuration.APPLICATION_ENVIRONMENT )
    configuration.APPLICATION_VERSION && _.set( options, 'release', configuration.APPLICATION_VERSION )
    configuration.SENTRY_TRACES_SAMPLE_RATE && _.set( options, 'tracesSampleRate', configuration.SENTRY_TRACES_SAMPLE_RATE )

    Sentry.init( options )

    if ( configuration.APPLICATION_HASH ) {
      Sentry.setTag( 'hash', configuration.APPLICATION_HASH )
    }
  }

  return true
}

export {
  CONFIGURATION,
  Sentry,
  initialize,
}
